import { render, staticRenderFns } from "./SafeArea.vue?vue&type=template&id=36c1a905&scoped=true"
import script from "./SafeArea.vue?vue&type=script&lang=ts"
export * from "./SafeArea.vue?vue&type=script&lang=ts"
import style0 from "./SafeArea.vue?vue&type=style&index=0&id=36c1a905&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c1a905",
  null
  
)

export default component.exports